



















































































































































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import MultiSelect from 'vue-multiselect';
import TicketHelper from '@/mixins/TicketHelper.vue';

@Component({
    components: {
        MultiSelect,
    },
    computed: {
        ...mapGetters({
            formVisible: 'Viewport/isEditFormVisible',
            ticketCategories: 'TicketAttributes/getTicketAllCategories',
            convertTicketAllTypes: 'Messages/getConvertTicketAllTypes',
            convertTicketAllCategories: 'Messages/getConvertTicketAllCategories',
            convertTicketAllStates: 'Messages/getConvertTicketAllStates',
            convertTicketAllAssignee: 'Messages/getConvertTicketAllAssignee',
            convertTicketAllWatchers: 'Messages/getConvertTicketAllWatchers',
        }),
    },
})
export default class CreateTicketForm extends Mixins(InputFieldMethods, TicketHelper) {
    @Prop() public formMode: string;

    public ticketTitle: string = '';
    public ticketMessage: string = '';
    public ticketCategory: any = '';
    public ticketType: any = '';
    public ticketPriority: any = 1;
    public ticketStatus: any = '';
    public ticketReceiver: any = '';
    public ticketAssignee: any = '';
    public ticketWatchers: any = [];
    public attchedFiles: any = [];

    constructor() {
        super();
    }

    get conversation() {
        return this.$store.getters['Messages/activeConversation'];
    }

    get errorCollection() {
        return this.errors.any();
    }

    public getVisibleState(state: string) {
        switch (state) {
            case 'new':
                return 'Pending';
                break;
            case 'open':
                return 'In-Progress';
                break;
            case 'closed':
                return 'Cancelled';
                break;
            default:
                return 'Completed';
                break;
        }
    }

    public addTicketAttachment(event: any) {
        const element = (event.target as HTMLInputElement);

        if (element.files.length === 0) {
            return;
        }

        for (const file of element.files) {
            this.attchedFiles.push(file as File);
        }

        element.type = 'text';
        element.type = 'file';
    }

    public returnFIleSrc(file: any) {
        return URL.createObjectURL(file);
    }

    public removeAttachItem(ev: any, index: number) {
        this.attchedFiles = this.attchedFiles.filter((file: any, i: number) => {
            return i !== index;
        });
    }

    public tenanatReceivers() {
        const receivers: any = [];
        this.conversation.participants.forEach((pt: any) => {
            const participant =  this.$store.getters['User/getCacheUser'](pt);
            if (participant && participant.isTenant) {
                receivers.push({id: participant.id, name: `${participant.firstName} ${participant.familyName}`});
            }
        });
        return receivers;
    }

    public adminCreateTicket() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                const formData: any = new FormData();
                formData.append('ticketTitle', this.ticketTitle);
                formData.append('ticketMessage', this.ticketMessage);
                formData.append('ticketCategory', this.ticketCategory);
                formData.append('ticketType', this.ticketType);
                formData.append('ticketStatus', this.ticketStatus);
                formData.append('ticketReceiver', this.ticketReceiver);
                formData.append('ticketPriority', this.ticketPriority);
                formData.append('ticketAssignee', this.ticketAssignee);
                formData.append('ticketWatchers', this.ticketWatchers.map((watcher: any) => watcher.id));

                this.attchedFiles.forEach((file: any) => {
                    formData.append('photos[]', file);

                });

                this.$store.dispatch(Actions.CONVERT_CONVERSATION_TICKET, {requestData: formData, conversationId: this.conversation.id, vue: this, type: 'admin'});
            }
        });
    }

    public fetchTicketCategories() {
        if (this.ticketType !== '') {
            this.$store.dispatch(Actions.FETCH_CONVERT_TICKET_ALL_CATEGORIES, {typeId: this.ticketType, propertyId: this.conversation.propertyId});
        } else {
            this.$store.commit(Mutations.SET_CONVERT_TICKET_ALL_CATEGORIES, []);
        }
        this.$store.commit(Mutations.SET_CONVERT_TICKET_ALL_ASSIGNEE, []);
        this.ticketCategory = '';
        this.ticketAssignee = '';
    }

    public fetchTicketAssignee() {
        if (this.ticketCategory !== '') {
            this.$store.dispatch(Actions.FETCH_CONVERT_TICKET_ALL_ASSIGNEE, this.ticketCategory);
        } else {
            this.$store.commit(Mutations.SET_CONVERT_TICKET_ALL_ASSIGNEE, []);
        }
        this.ticketAssignee = '';
    }

    public beforeDestroy() {
        this.cancel();
    }

    public cancel() {
        this.$store.commit(Mutations.SET_TICKET_CREATE_FORM_VISIBILITY, false);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_CONVERT_TICKET_ALL_TYPES);
        this.$store.dispatch(Actions.FETCH_CONVERT_TICKET_ALL_STATES);
        this.$store.dispatch(Actions.FETCH_CONVERT_TICKET_ALL_WATCHERS);

        if (this.conversation.title !== null && this.conversation.title.trim() !== '') {
            this.ticketTitle = this.conversation.title;
        }
    }
}
